import { Eye, EyeOff } from "lucide-react";
import { type ComponentProps, useState } from "react";

import { Input } from "@/components/ui";
import { cn } from "@/utils/cn";

interface PasswordInputProps extends Omit<ComponentProps<typeof Input>, "type"> {}

export const PasswordInput = ({ className, ...props }: PasswordInputProps) => {
  const [show, setShow] = useState(false);

  return (
    <div className="relative">
      <Input
        type={show ? "text" : "password"}
        className={cn("pr-12", className)}
        {...props}
      />
      <button
        type="button"
        onClick={() => setShow((prev) => !prev)}
        className="absolute top-1/2 right-4 -translate-y-1/2 text-muted-foreground transition-colors hover:text-foreground"
        aria-label={show ? "Hide password" : "Show password"}
      >
        {show ? <Eye className="size-5" /> : <EyeOff className="size-5" />}
      </button>
    </div>
  );
};
